import { generateClient } from 'aws-amplify/data';

const client = generateClient({ authMode: 'userPool' });

export interface AuditEntry {
  actionType: string;
  targetEntityType?: string;
  targetEntityId?: string;
  description: string;
  metadata?: Record<string, any>;
}

/**
 * Log an admin action to the AuditLog table.
 * Fire-and-forget — never blocks the calling operation.
 */
export async function logAuditEntry(
  adminEmail: string,
  adminSub: string,
  entry: AuditEntry
): Promise<void> {
  try {
    await (client.models as any).AuditLog.create({
      adminEmail,
      adminSub,
      actionType: entry.actionType,
      targetEntityType: entry.targetEntityType || undefined,
      targetEntityId: entry.targetEntityId || undefined,
      description: entry.description,
      metadata: entry.metadata ? JSON.stringify(entry.metadata) : undefined,
      timestamp: new Date().toISOString(),
    });
  } catch (err) {
    console.error('Failed to write audit log:', err);
    // Never throw — audit logging must not break the primary operation
  }
}
